import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const snapshotSourceSchema = z.enum(["USER_SAVE", "AI_TAILOR", "IMPORT"]);

export const createSnapshotSchema = z.object({
  source: snapshotSourceSchema,
});

export class CreateSnapshotDto extends createZodDto(createSnapshotSchema) {}

export const restoreSnapshotSchema = z.object({
  snapshotId: z.string(),
});

export class RestoreSnapshotDto extends createZodDto(restoreSnapshotSchema) {}

export const snapshotItemSchema = z.object({
  id: z.string(),
  resumeId: z.string(),
  source: snapshotSourceSchema,
  createdAt: z.string().datetime(),
});

export const resumeSnapshotSchema = snapshotItemSchema.extend({
  changedSections: z.array(z.string()).optional(),
  label: z.string().optional(),
});

export const snapshotDetailSchema = snapshotItemSchema.extend({
  data: z.record(z.unknown()),
});

export const paginatedSnapshotsSchema = z.object({
  items: z.array(snapshotItemSchema),
  page: z.number().int().min(1),
  limit: z.number().int().min(1).max(50),
  total: z.number().int().nonnegative(),
});

export class ResumeSnapshotDto extends createZodDto(resumeSnapshotSchema) {}

export type SnapshotSource = z.infer<typeof snapshotSourceSchema>;
export type SnapshotItem = z.infer<typeof snapshotItemSchema>;
export type SnapshotDetail = z.infer<typeof snapshotDetailSchema>;
export type PaginatedSnapshotsDto = z.infer<typeof paginatedSnapshotsSchema>;
export type ResumeSnapshot = z.infer<typeof resumeSnapshotSchema>;
